import { Button, ButtonProps } from "../button/button";
import { Tooltip } from "../tooltip/tooltip";

export type ToggleButtonProps = Omit<ButtonProps, "aria-label" | "onToggle"> & {
  ariaLabelOff: string;
  ariaLabelOn: string;
  isSelected?: boolean;
  isTooltipDisabled?: boolean;
  onToggle?: () => void;
  ref?: React.Ref<HTMLButtonElement>;
};

export function ToggleButton({
  children,
  isSelected,
  isTooltipDisabled,
  onToggle,
  ref,
  ...props
}: ToggleButtonProps) {
  const buttonElement = (
    <Button
      {...props}
      ref={ref}
      aria-label={isSelected ? props.ariaLabelOn : props.ariaLabelOff}
      aria-pressed={isSelected}
      data-selected={isSelected}
      onPress={onToggle}
    >
      {children}
    </Button>
  );

  if (props.isIconOnly && !isTooltipDisabled) {
    return (
      <Tooltip content={isSelected ? props.ariaLabelOn : props.ariaLabelOff}>
        {buttonElement}
      </Tooltip>
    );
  }

  return buttonElement;
}

ToggleButton.displayName = "RecareUI.ToggleButton";
